import { CategoryGame } from '../../../state/shared/categories.types';


export const getReducedGameIds = (games?: CategoryGame[]) =>
  games?.slice(0, 150).map((game) => game.id) ?? [];
